import React from 'react';
import { eye } from 'react-icons-kit/icomoon/eye';
import Button from '../../../components/Button';
import IconButton from '../../../components/IconButton';

const StatusBar = (props)=>{
    return(
        <div className="col-xs-12 form-group status-bar">
            <label style={{color:"black",padding:"8px"}}>Estatus</label>
            <IconButton 
                class={
                    props.colorStatusBar === 'red' ? "btn btn-danger col-sm-1" : 
                    props.colorStatusBar === 'green' ? "btn btn-success col-sm-1" : "btn col-sm-1"
                }
                title="Estatus"
                action={props.action}
                icon={eye}
            />
        </div>
    )
}

export default StatusBar